import React from "react";
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-68" data-mp="3f2n7hz61iurj">
      <p className={`text-xs font-extrabold uppercase tracking-[0.16em] sm:text-sm ${dark ? "text-gold" : "text-brand"}`} data-id="element-69" data-mp="3jznce6r5lrh2">
        {eyebrow}
      </p>
      <h2 className={`mt-3 text-[28px] font-black leading-[1.15] tracking-tight sm:text-4xl lg:text-[44px] ${dark ? "text-white" : "text-ink"}`} data-id="element-70" data-mp="bl5akmrt385w">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? "text-white/75" : "text-ink-muted"}`} data-id="element-71" data-mp="6tn8fve1r1jc">{subtitle}</p>}
    </div>;
}